<template>
   <div>
       <div class="style_button"
            v-for="(style_data, index) in $store.state.xlsx_data.style_group1_pick"
            v-if="$store.state.search_data[style_data.style] !== '×'"
       >
           <input type="radio"
                  v-if="style_data.name==='プレーンシェード'"
                  v-bind:id="'style_'+style_data.style_id"
                  v-model="style_selected2"
                  v-bind:value="style_data.style_id"
                  v-bind:disabled="$store.state.search_data[style_data.style]==='×'"
           >
           <input type="radio"
                  v-else
                  v-bind:id="'style_'+style_data.style_id"
                  v-model="style_selected1"
                  v-bind:value="style_data.style_id"
                  v-bind:disabled="$store.state.search_data[style_data.style]==='×'"
           >
           <!--                    {{$store.state.search_data[style_data.style]}}:-->
           <label class="col01"
                  v-bind:for="'style_'+style_data.style_id"
                  v-bind:class="{disabled_label:$store.state.search_data[style_data.style]=='×'}"
                  v-on:click="no_select_rule(style_data.style,$store.state.search_data)"
           >
               <img v-if="style_data.name==='プレーンシェード'" class="svg_icon" v-bind:src="[style_selected2===style_data.style_id ? './assets/images/'+style_data.svg+'_o.svg' : './assets/images/'+style_data.svg+'.svg']">
               <img v-else class="svg_icon" v-bind:src="[style_selected1===style_data.style_id ? './assets/images/'+style_data.svg+'_o.svg' : './assets/images/'+style_data.svg+'.svg']">
               <!--                        <span class="svg_icon" v-html="svg_html[style_data.svg]"></span>-->
               <p v-if="style_data.name==='スタンダード縫製'" class="style_name">カーテン<br>形態安定加工なし</p>
               <p v-else-if="style_data.name==='ソフトウェーブ縫製'" class="style_name">カーテン<br>形態安定加工付</p>
               <p v-else-if="style_data.name==='ファインウェーブ縫製'" class="style_name">カーテン<br><span style="font-size: 0.6rem;">上級形態安定加工付</span></p>
               <p v-else class="style_name">{{style_data.name}}</p>
           </label>
       </div>
   </div>
</template>

<script>
    export default {
        name: "Accordion2",
        props: {
            style_data : Object,
            index : Number
        },
        computed: {
            style_selected1: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_id
                },
                set: function (value) {
                    this.$store.commit('updateStyleSelected1', value)
                    //this.$store.dispatch('priceCheck')
                }
            },
            style_selected2: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_id
                },
                set: function (value) {
                    this.$store.commit('updateStyleSelected2', value)
                    //this.$store.dispatch('priceCheck')
                }
            }
        },
        data() {
            return {
            }
        },
        methods:{
            changeIcon: function(){
                //console.log()
            },
            /**
             * 対応不可理由の更新処理
             * @param style_name
             * @param style_result
             */
            no_select_rule : function(style_name,style_result){
                const item_num = this.$store.state.step1_data.item_number
                const no_select_data = this.$store.state.xlsx_data.no_select_result['FT'+item_num]

                if(style_result[style_name]=='×'){
                    //対応不可理由の更新
                    this.$store.state.now_no_select_result = no_select_data[style_name]
                    this.showModal()
                }
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-2', '#btnShow')
            },
            load_svg: function(_file_name){
                const req = new XMLHttpRequest()
                req.open('GET', './assets/images/'+_file_name, true)
                req.responseType = 'text'
                const scope = this

                //ローディングをつける　TODO
                req.onload = function () {
                    if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                        return false
                    }
                    //データを処理
                    //document.getElementById("living").appendChild( req.responseXML )
                    scope.svg_html[_file_name] = req.responseText
                }
                req.onerror = function() {
                    return false
                }
                req.send();
            },
        }
    }
</script>

<style scoped>
    .accordion_onoff{
        display: none;
    }
</style>